<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap class="ch-info-component">
      <v-flex xs12>
        <v-card>
          <v-card-title class="head">
            <v-layout row wrap>
              <v-flex xs12>
                <i class="fas fa-user-circle fa-fw"></i>
                <span class="info-name ml-2">{{ (name !== null) ? name : 'None' }}</span>
                <!-- <button class="ml-2" @click="copyText">
                  <i class="far fa-clone"></i>
                </button> -->
                <span class="box">
                  <span class="name">UPDATED</span>
                  <span class="time">{{ updated_at }}</span>
                </span>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text class="body ch-info-field-border">
            <v-layout row wrap class="ch-info-field-wrapper ma-0 pb-3">
              <v-flex xs6 class="pa-0">
                <div class="ch-info-field">
                  <div class="ch-info-field-title">
                    <i class="fas fa-user fa-fw"></i>
                    <span class="ml-2">NAME</span>
                  </div>
                  <div class="ch-info-field-body">
                    <v-text-field
                      class="pt-0"
                      v-model="name"
                    ></v-text-field>
                  </div>
                </div>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <div class="ch-info-field">
                  <div class="ch-info-field-title">
                    <i class="fas fa-exclamation-circle fa-fw"></i>
                    <span class="ml-2">TYPE</span>
                  </div>
                  <div class="ch-info-field-body">
                    <v-text-field
                      class="pt-0"
                      v-model="type"
                      disabled
                    ></v-text-field>
                  </div>
                </div>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <div class="ch-info-field">
                  <div class="ch-info-field-title">
                    <i class="fas fa-file-alt fa-fw"></i>
                    <span class="ml-2">DESCRIPTION</span>
                  </div>
                  <div class="ch-info-field-body">
                    <v-text-field
                      class="pt-0"
                      v-model="desc"
                    ></v-text-field>
                  </div>
                </div>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <div class="ch-info-field">
                  <div class="ch-info-field-title">
                    <i class="fas fa-calendar-check fa-fw"></i>
                    <span class="ml-2">CREATED AT</span>
                  </div>
                  <div class="ch-info-field-body">
                    <v-text-field
                      class="pt-0"
                      v-model="created_at"
                      disabled
                    ></v-text-field>
                  </div>
                </div>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <div class="ch-info-field">
                  <div class="ch-info-field-title">
                    <i class="fas fa-question fa-fw"></i>
                    <span class="ml-2">DOMAIN INIT CARD</span>
                  </div>
                  <div class="ch-info-field-body">
                    <v-select
                      class="pt-0"
                      :items="domainInitCardOptions"
                      v-model="use_domain_init_card"
                      content-class="detail-select"
                    ></v-select>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <div class="btn-wrapper">
              <router-link :to="{name: 'domains'}">
                <button class="ch-menu-btn ch-menu-backbtn" type="button">
                  <i class="fas fa-angle-left fa-fw"></i>
                  LIST
                </button>
              </router-link>
              <v-spacer></v-spacer>
              <button
                class="save"
                @click="updateDomain"
                :disabled="!isValid"
              >
                <i class="fas fa-save fa-fw"></i>
                <span>SAVE</span>
              </button>
              <!-- <button
                class="cancel"
                @click="openDeleteDialog"
              >
                <i class="fas fa-times-circle fa-fw"></i>
                <span>CANCEL</span>
              </button> -->
              <!-- NOTE: Delete Dialog -->
              <v-dialog v-model="deleteDialog" max-width="300">
                <v-card>
                  <v-card-title class="headline">Do you want to delete it?</v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error darken-1" flat="flat" @click.native="deleteDialog = false">Cancel</v-btn>
                    <v-btn color="primary darken-1" flat="flat" @click.native="deleteDomain">Delete</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  // import { `domainsEventBus` } from '@/components/admin/domains/domainsEventBus';
  import api from '../../../api';

  export default {
    data() {
      return {
        id: null,
        name: null,
        desc: null,
        type: null,
        domainInitCardOptions: [
          { text: 'OFF', value: false },
          { text: 'ON', value: true },
        ],
        use_domain_init_card: false,
        created_at: null,
        updated_at: null,
        // NOTE: Dialog
        createDialog: false,
        deleteDialog: false,
        // NOTE: validation
        rules: {
          required: value => !!value || 'Required.',
        },
      };
    },
    methods: {
      getDomainDetail() {
        api.getDomainDetail(this.id)
        .then((result) => {
          if (result.status === 200) {
            console.log(JSON.stringify(result.data));
            Object.assign(this, result.data);
            this.created_at = this.$moment(result.data.created_at).format('YYYY-MM-DD HH:mm:ss');
            this.updated_at = this.$moment(result.data.updated_at).format('YYYY-MM-DD HH:mm:ss');
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
          // NOTE: 삭제된 아이템
          if (err.response.status === 404) {
            console.error('Invalid page', err.response);
            this.$router.push({ name: 'domains' });
          }
        });
      },
      updateDomain() {
        console.log(`user_domain_init_card: ${this.use_domain_init_card}`);
        const id = this.id;
        const params = {
          name: this.name,
          email: this.email,
          desc: this.desc,
          use_domain_init_card: this.use_domain_init_card,
          password: this.password,
        };

        api.updateDomain(id, params)
        .then((result) => {
          if (result.status === 200) {
            Object.assign(this, result.data);
            this.created_at = this.$moment(result.data.created_at).format('YYYY-MM-DD HH:mm:ss');
            this.updated_at = this.$moment(result.data.updated_at).format('YYYY-MM-DD HH:mm:ss');
            this.alert.type = 'check_circle';
            this.alert.color = 'green';
            this.alert.message = 'Success Save';
            this.alertOccur();
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      deleteDomain() {
        const id = this.id;

        api.deleteDomain(id)
        .then((result) => {
          if (result.status === 200) {
            this.alert.type = 'check_circle';
            this.alert.color = 'green';
            this.alert.message = 'Success delete';
            this.alertOccur();
            this.deleteDialog = false;
            // 리다이렉트 // 근데 여기서 얼럿보여주면 안됌
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      openDeleteDialog() {
        this.deleteDialog = true;
      },
      // TODO: 내용정리필요
      isValid() {},
      /**
       * TODO: 정리필요
       * @description 정보창 상단 타이틀 복사
       */
      // copyText() {
      //   const copyTextInfo = document.createElement('input');
      //   const body = document.getElementsByTagName('body')[0];
      //   body.appendChild(copyTextInfo);
      //   copyTextInfo.value = this.name;
      //   copyTextInfo.select();
      //   document.execCommand('Copy');
      //   copyTextInfo.remove();
      // },
    },
    mounted() {
      this.id = this.$route.params.id;
      this.getDomainDetail();
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/domains/DomainsDetailInfo.vue